import { ResponsiveAccordionTabs } from 'foundation-sites/dist/js/foundation.esm.js'
import easydropdown from 'easydropdown-a11y'

const SELECTORS = Selectors({
  searchPanel: 'element-librarysearch'
})

const $searchPanels = document.querySelectorAll(SELECTORS.asClass('searchPanel'))

const fn = {
  init: () => {
    $searchPanels.forEach(el => {
      const $tabs = $(el).find('.library-search-tabs')

      $tabs.find('select').each((_, el) => {
        easydropdown(el, {
          behavior: {
            liveUpdates: true,
            openOnFocus: true
          }
        })
      })

      new ResponsiveAccordionTabs($tabs)
    })
  }
}

export default {
  can: () => $searchPanels.length,
  run: fn.init
}
